import { Contact, MessagingSettings } from "@apaq/orgkit-js";

export class NotificationHelper {
  public static isNotificationPossible(contact: Contact | undefined, messagingSettings: MessagingSettings | undefined) {
    if (contact == null) return false;
    let methods = contact.notificationDeliveryMethods;
    if (methods == null && messagingSettings != null) {
      methods = messagingSettings.notificationDeliveryMethods;
    }

    if (methods == null) {
      methods = [];
    }

    return (contact.phone != null && methods.indexOf('Sms') >= 0) ||
      (contact.email != null && methods.indexOf('Email') >= 0);
  }

  public static isNotificationWantedForEvent(eventType: 'assignment.completed' | 'assignment.impending', contact: Contact | undefined, messagingSettings: MessagingSettings | undefined) {
    const notificationEvents = contact?.notificationEvents != null ? contact.notificationEvents : messagingSettings?.notificationEvents;
    return notificationEvents != null && notificationEvents.includes(eventType);
  }
}